@switch (item.type) {
  @case ('button') {
    <hr />
  }
}
@switch (item.type) {
  @case ('item') {
    <a
      class="menu-item"
      [class.active]="isActive"
      href="javascript:void(0)"
      [ngClass]="item.classes"
      (click)="onNavItemClick(item.url)">
      <b class="icon">
        @if (item.icon) {
          <i [class]="item.icon"></i>
        }
      </b>
      <span>{{ item.translate | translate }}</span>
    </a>
  }
  @case ('button') {
    <div class="plr15 acenter">
      <a
        class="simple-btn simple-btn-lg simple-btn-lg-nav simple-btn-rounded simple-btn-accent simple-btn-shadow"
        href="javascript:void(0)"
        [ngClass]="item.classes"
        [class.active]="isActive"
        (click)="onNavItemClick(item.url)">
        <span>{{ item.translate | translate }}</span>
      </a>
    </div>
  }
}
